import React, { useState } from 'react';
import ReactQuillOriginal from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import './RichTextEditor.css';
import type { ComponentType } from 'react';

const ReactQuill = ReactQuillOriginal as unknown as ComponentType<any> & { Quill: any };

// Configure Quill to use inline styles instead of classes for better email compatibility
if (ReactQuill.Quill) {
    const Quill = ReactQuill.Quill;
    const AlignStyle = Quill.import('attributors/style/align');
    const ColorStyle = Quill.import('attributors/style/color');
    const BackgroundStyle = Quill.import('attributors/style/background');
    const SizeStyle = Quill.import('attributors/style/size');

    Quill.register(AlignStyle, true);
    Quill.register(ColorStyle, true);
    Quill.register(BackgroundStyle, true);
    Quill.register(SizeStyle, true);
}

const RichTextEditor = React.forwardRef(({ value, onChange, placeholder }: any, ref: any) => {
    const modules = {
        toolbar: [
            [{ 'header': [1, 2, 3, false] }],
            [{ 'size': ['small', false, 'large', 'huge'] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ 'color': [] }, { 'background': [] }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'align': [] }],
            ['link', 'image'],
            ['clean']
        ],
    };

    const formats = [
        'header',
        'size',
        'bold', 'italic', 'underline', 'strike',
        'color', 'background',
        'list', 'bullet',
        'align',
        'link', 'image'
    ];

    return (
        <div className="rich-text-editor-container">
            <ReactQuill
                ref={ref}
                theme="snow"
                value={value}
                onChange={onChange}
                modules={modules}
                formats={formats}
                placeholder={placeholder || "Write something amazing..."}
            />
        </div>
    );
});

export default RichTextEditor;
